import React, { useState } from "react";
import moment from "moment";
import CustomTable from "../../../../components/Tables/CustomTable";
import { useAppSelector } from "../../../../redux/app/hooks";
import DropdownMenu from "../../../ui/DropdownMenu";
import { MoreVertical } from "lucide-react";
import AddCourierdBranch from "./AddBranch";
import EditCourierBranch from "./EditBranch";
import DeleteBranchModal from "./DeleteBranch";

const BranchTable = ({
  page,
  setPage,
  setLimit,
  openAddBranch,
  setOpenAddBranch,
  onUpdate,
}: {
  page: number;
  setPage: any;
  setLimit: any;
  openAddBranch: any;
  setOpenAddBranch: any;
  onUpdate: () => void;
}) => {
  const { loading, courierOffices } = useAppSelector((state) => state.courier);
  const [openEditBranch, setOpenEditBranch] = useState(false);
  const [disableBranch, setDisableBranch] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState<any>();

  const dropdownOptionsForBranch = (isEnabled: boolean) => {
    return [
      {
        label: "Edit branch",
        onClick: (branch: any) => {
          setOpenEditBranch(true);
          setSelectedBranch(branch);
        },
        returnAll: true,
      },
      {
        label: isEnabled ? (
          <span className="text-red-500">Disable branch</span>
        ) : (
          <span className="text-green-500">Enable branch</span>
        ),
        onClick: (branch: any) => {
          setDisableBranch(true);
          setSelectedBranch(branch);
        },
        returnAll: true,
      },
    ];
  };

  const branchesData = {
    columns: [
      { label: "S/N", field: "id" },
      { label: "Branch Name", field: "name" },
      { label: "Address", field: "address" },
      { label: "City", field: "city" },
      { label: "State", field: "state" },
      { label: "Country", field: "country" },
      { label: "Status", field: "status" },
      { label: "Reg Date", field: "reg_date" },
      { label: "Action", field: "action" },
    ],
    rows: courierOffices?.data?.data?.map((item: any, index: number) => {
      return {
        id: index + 1,
        name: item?.name,
        address: item?.address,
        state: item?.state?.name,
        city: item?.city?.name,
        country: item?.country?.name,
        reg_date: moment(item?.createdAt).format("Do MMM YYYY"),
        status: item?.isEnabled ? (
          <span className="text-green-500">Enabled</span>
        ) : (
          <span className="text-red-500">Disabled</span>
        ),
        action: (
          <DropdownMenu
            options={dropdownOptionsForBranch(item?.isEnabled)}
            icon={<MoreVertical style={{ cursor: "pointer" }} />}
            item={item}
          />
        ),
      };
    }),
  };

  return (
    <>
      <CustomTable
        data={branchesData}
        noRecordText="No Order Available"
        loading={loading}
        showFooter={true}
        totalPages={courierOffices?.data?.totalPages}
        itemsPerPage={courierOffices?.data?.dataPerPage}
        currentPage={page}
        onPageChange={(value: number) => setPage(value)}
        onLimitChange={(value: number) => {
          setLimit(value);
          setPage(0);
        }}
      />
      <AddCourierdBranch
        open={openAddBranch}
        onClose={() => setOpenAddBranch(false)}
      />
      <EditCourierBranch
        open={openEditBranch}
        onClose={() => setOpenEditBranch(false)}
        selectedBranch={selectedBranch}
        onSave={onUpdate}
      />
      <DeleteBranchModal
        isOpen={disableBranch}
        onClose={() => setDisableBranch(false)}
        branchId={selectedBranch?.id}
        onConfirm={onUpdate}
        currentStatus={selectedBranch?.isEnabled}
      />
    </>
  );
};

export default BranchTable;
